export enum InfoTextTypeEnum {
  BLOCK = 'column',
  INLINE = 'row'
}
